import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './contactFormInitialState';
import {
  _setNewContactForm,
  _setCntId,
  _setCntKey,
  _setCntDept,
  _setAuthLock,
  _setHonorific,
  _setPhone,
  _setFax,
  _setCntOrgId,
  _setPlacementCoordinator,
  _setCaseManager,
  _setParoleAgent,
  _setSupervisorChkBox,
  _setDataEntry,
  _setCntInactiveYn,
  _setNetworkUserName,
  _setCounty,
  _setCntSprCntId,
  _setCntEditCntId,
  _setCntName,
  _setFirstName,
  _setMiddleName,
  _setLastName,
  _setSuffix,
  _setTitle,
  _setDirectPhone,
  _setCntMailAdrPrefix,
  _setCntMailAdr,
  _setAddress1,
  _setAddress2,
  _setCity,
  _setState,
  _setZip,
  _setEmail,
  _setCreatedDate,
  _setEditDate,
  _setComment,
  _setCntCreateCntId,
  _setProbationOfficer,
  _setOrganization,
  _setContactCreatedby,
  _setContactEditedby,
} from './contactFormActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getContactForm = createAsyncThunk(
  'stop/getContactForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const contactFormSlice = createSlice({
  name: 'stop/contactForm',
  initialState,
  reducers: {
    setNewContactForm: _setNewContactForm,
    setCntId: _setCntId,
    setCntKey: _setCntKey,
    setCntDept: _setCntDept,
    setAuthLock: _setAuthLock,
    setHonorific: _setHonorific,
    setPhone: _setPhone,
    setFax: _setFax,
    setCntOrgId: _setCntOrgId,
    setPlacementCoordinator: _setPlacementCoordinator,
    setCaseManager: _setCaseManager,
    setParoleAgent: _setParoleAgent,
    setSupervisorChkBox: _setSupervisorChkBox,
    setDataEntry: _setDataEntry,
    setCntInactiveYn: _setCntInactiveYn,
    setNetworkUserName: _setNetworkUserName,
    setCounty: _setCounty,
    setCntSprCntId: _setCntSprCntId,
    setCntEditCntId: _setCntEditCntId,
    setCntName: _setCntName,
    setFirstName: _setFirstName,
    setMiddleName: _setMiddleName,
    setLastName: _setLastName,
    setSuffix: _setSuffix,
    setTitle: _setTitle,
    setDirectPhone: _setDirectPhone,
    setCntMailAdrPrefix: _setCntMailAdrPrefix,
    setCntMailAdr: _setCntMailAdr,
    setAddress1: _setAddress1,
    setAddress2: _setAddress2,
    setCity: _setCity,
    setState: _setState,
    setZip: _setZip,
    setEmail: _setEmail,
    setCreatedDate: _setCreatedDate,
    setEditDate: _setEditDate,
    setComment: _setComment,
    setCntCreateCntId: _setCntCreateCntId,
    setProbationOfficer: _setProbationOfficer,
    setOrganization: _setOrganization,
    setContactCreatedby: _setContactCreatedby,
    setContactEditedby: _setContactEditedby,
    resetContactForm: (state) => initialState,
  },
  extraReducers: {
    [getContactForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setNewContactForm,
  setCntId,
  setCntKey,
  setCntDept,
  setAuthLock,
  setHonorific,
  setPhone,
  setFax,
  setCntOrgId,
  setPlacementCoordinator,
  setCaseManager,
  setParoleAgent,
  setSupervisorChkBox,
  setDataEntry,
  setCntInactiveYn,
  setNetworkUserName,
  setCounty,
  setCntSprCntId,
  setCntEditCntId,
  setCntName,
  setFirstName,
  setMiddleName,
  setLastName,
  setSuffix,
  setTitle,
  setDirectPhone,
  setCntMailAdrPrefix,
  setCntMailAdr,
  setAddress1,
  setAddress2,
  setCity,
  setState,
  setZip,
  setEmail,
  setCreatedDate,
  setEditDate,
  setComment,
  setCntCreateCntId,
  setProbationOfficer,
  setOrganization,
  setContactCreatedby,
  setContactEditedby,
  resetContactForm,
} = contactFormSlice.actions;

export default contactFormSlice.reducer;
